module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Charles The"), _c('br'), _vm._v(" Great - Charlemagne")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#prologue"
    }
  }, [_vm._v("Prologue")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-1-the-crowning"
    }
  }, [_vm._v("Chapter 1: The Crowning")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#chapter-2-insurrection",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Insurrection")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-3-désirée",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Désirée")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-4-the-saxon-campaign",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: The Saxon Campaign")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-5-italian-campaign",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Italian Campaign")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-6-roncevalles",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Roncevalles")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-7-verden",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Verden")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-8-tassilo-iii-duke-of-bavaria",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Tassilo III – Duke of Bavaria")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-9-the-avars",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The Avars")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-10-pope-leo-iii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Pope Leo III")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-11-king-and-emperor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: King and Emperor")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-12-the-final-years",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: The Final Years")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0